import React, { useState } from "react";
import { CheckCircle2, Copy } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { CITIZEN } from "@/constants/testIds";

const DISTRICTS = ["Ludhiana","Amritsar","Jalandhar","Patiala","Bathinda","Mohali","Sangrur","Hoshiarpur","Ferozepur","Moga","Faridkot","Kapurthala","Barnala","Fazilka","Gurdaspur","Mansa","Muktsar","Nawanshahr","Rupnagar","Tarn Taran","Pathankot","Malerkotla"];
const CATEGORIES = ["Subsidy","Application Delay","Site Issue","Vendor Complaint","Information Request","Other"];

export default function GrievancePage() {
  const [form, setForm] = useState({ subject:"", category:"Subsidy", description:"", district:"", contact_name:"", contact_phone:"", contact_email:"" });
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setError("");
    try {
      const { data } = await api.post("/grievances", form);
      setResult(data);
    } catch (e) { setError(formatErr(e.response?.data?.detail) || e.message); }
  };

  if (result) {
    return (
      <div className="container-x py-16 max-w-xl">
        <div data-testid="grievance-success" className="rounded-2xl border border-emerald-400/30 bg-emerald-500/5 p-8 text-center">
          <CheckCircle2 className="h-14 w-14 mx-auto text-emerald-500"/>
          <h1 className="mt-4 text-3xl font-heading font-bold">Grievance registered</h1>
          <p className="mt-2 text-muted-foreground">SLA-based resolution begins now. Track using this ID.</p>
          <div className="mt-6 rounded-xl bg-card border border-border p-4 flex items-center justify-between gap-3">
            <div>
              <div className="label-tiny text-muted-foreground">Tracking ID</div>
              <div className="font-mono font-semibold">{result.tracking_id}</div>
            </div>
            <button className="btn-outline" onClick={()=>navigator.clipboard.writeText(result.tracking_id)}><Copy className="h-4 w-4"/></button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-x py-12 max-w-3xl">
      <div className="label-tiny text-[hsl(var(--primary))]">Public Grievance</div>
      <h1 className="mt-1 text-3xl font-heading font-bold">Register a grievance</h1>
      <p className="mt-2 text-muted-foreground">We aim to acknowledge every grievance within 48 hours and resolve within SLA.</p>
      <form onSubmit={submit} className="mt-8 rounded-2xl border border-border bg-card p-6 grid sm:grid-cols-2 gap-4">
        <F label="Subject" cols="2"><input required className="input" value={form.subject} onChange={change("subject")}/></F>
        <F label="Category">
          <select className="input" value={form.category} onChange={change("category")}>
            {CATEGORIES.map(c=><option key={c}>{c}</option>)}
          </select>
        </F>
        <F label="District"><select className="input" value={form.district} onChange={change("district")}>
          <option value="">-- Select --</option>
          {DISTRICTS.map(d=><option key={d}>{d}</option>)}
        </select></F>
        <F label="Your name"><input required className="input" value={form.contact_name} onChange={change("contact_name")}/></F>
        <F label="Phone"><input required className="input" value={form.contact_phone} onChange={change("contact_phone")}/></F>
        <F label="Email" cols="2"><input type="email" className="input" value={form.contact_email} onChange={change("contact_email")}/></F>
        <F label="Description" cols="2"><textarea required rows={4} className="input" value={form.description} onChange={change("description")}/></F>
        {error && <div className="sm:col-span-2 text-red-500 text-sm">{error}</div>}
        <button data-testid={CITIZEN.grievanceSubmit} className="btn-primary sm:col-span-2 justify-self-start" type="submit">Submit grievance</button>
      </form>
    </div>
  );
}

function F({ label, cols, children }) {
  return (
    <label className={`flex flex-col gap-1.5 ${cols === "2" ? "sm:col-span-2" : ""}`}>
      <span className="text-xs font-semibold text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}
